import {
  ProductEvent,
  type ProductEventTarget,
} from "../product-events/ProductEventTarget";
import { AnalyticsPort } from "./AnalyticsPort";

const analyticsEventNames = [
  "chat_start",
  "followup_message_send",
  "filter_change",
  "citation_expand",
  "citation_follow",
  "reference_remove",
  "login",
  "message_retry",
  "exception",
] as const;

export type AnalyticsEventName = (typeof analyticsEventNames)[number];

export class ProductAnalytics {
  constructor(private readonly analyticsAdapter: AnalyticsPort) {}
  private readonly eventHandlers: Map<AnalyticsEventName, EventListener> =
    new Map();

  subscribeToEvents(events: ProductEventTarget) {
    const eventNames = analyticsEventNames;

    for (const eventName of eventNames) {
      const handler = (event: Event) => {
        const params = (event as ProductEvent).detail;
        this.analyticsAdapter.logEvent(eventName, params);
      };
      this.eventHandlers.set(eventName, handler);
      events.addEventListener(eventName, handler);
    }
  }

  unsubscribeFromEvents(events: ProductEventTarget) {
    for (const [eventName, handler] of this.eventHandlers) {
      events.removeEventListener(eventName, handler);
    }
    this.eventHandlers.clear();
  }
}
